// API client for lesson comments (/comments).

const baseAPI_URL = process.env.REACT_APP_BACKEND_API_BASE_ENDPOINT;

async function request(path, { token, method = "GET", body } = {}) {
  const response = await fetch(`${baseAPI_URL}/comments${path}`, {
    method,
    headers: {
      ...(body ? { "Content-Type": "application/json" } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const error = new Error(data?.error || "Não foi possível completar a requisição.");
    error.status = response.status;
    throw error;
  }

  return data;
}

/**
 * Latest lesson comments for the feed (newest first).
 * GET /comments/latest?offset=&limit=
 */
export async function getLatestComments(token, { offset = 0, limit = 20 } = {}) {
  const params = new URLSearchParams({
    offset: String(offset),
    limit: String(limit),
  });
  return request(`/latest?${params}`, { token });
}
